import Vue from 'vue';
import modal from './modal/index';

Vue.use(modal);
